import { put, call, takeLatest, select } from 'redux-saga/effects';
import { initiateFetchSkus, fetchSkusSuccess, fetchSkusError } from '../actions/skus';
import { FETCH_SKUS } from '../actions/types';
import { getLiveSkus } from '../services/skus';
import { processCartSku } from '../utils';
import { showErrorMsg } from '../actions/snackbar';
import { saveCartSuccess } from '../actions/cart';
import { validateSession } from './session';

function* fetchSkus(action) {
	try {
		const { payload: { selectedPod = {}, affiliateUrl } = {} } = action;
		yield put(initiateFetchSkus());
		const { sessionId } = yield select((state) => state.auth || {});
		let skuData = yield call(
			validateSession,
			getLiveSkus,
			selectedPod.imei,
			selectedPod.mobile,
			affiliateUrl,
			sessionId
		);
		let skuArray = [];
		for (const skus of Object.values(skuData)) {
			skuArray = [
				...skuArray,
				...skus
					.map((skuData) => {
						const key = `${skuData.tray_id}-${skuData.sku_id}`;
						return [key, { ...skuData, key }];
					})
					.sort(([, sku1], [, sku2]) => +sku1.tray_id - +sku2.tray_id),
			];
		}

		skuData = new Map(skuArray);
		const cart = yield select((state) => state.cart);
		let newSkuData = skuData;
		if (cart && cart.imei === selectedPod.imei) {
			const { skus, cartState, cartUpdated } = processCartSku(skuData, cart);
			newSkuData = skus;
			if (cartUpdated) {
				yield put(saveCartSuccess(cartState));
				yield put(
					showErrorMsg(`Cart changed due to unavailability.
          Please click on cart to check changes`)
				);
			}
		}

		yield put(fetchSkusSuccess(newSkuData));
	} catch (error) {
		yield put(fetchSkusError(error));
		yield put(showErrorMsg(error.message));
	}
}
export function* watchSkus() {
	yield takeLatest(FETCH_SKUS, fetchSkus);
}
